import supabase from '../supabaseClient';

const FN_URL = "https://fmzyvyhgqhrpfpsdwtcu.supabase.co/functions/v1";

// ── Llamadas a Edge Functions del plan FREE (self-service) ───────
// Mismo patrón que services/superadmin.js: siempre el access_token real
// de la sesión, la Edge Function revalida rol === 'cliente' en el servidor.
const llamarFreeFn = async (nombre, body) => {
  const { data: { session } } = await supabase.auth.getSession();
  const r = await fetch(`${FN_URL}/${nombre}`, {
    method: "POST",
    headers: { "Content-Type": "application/json", "Authorization": `Bearer ${session?.access_token}` },
    body: JSON.stringify(body)
  });
  const data = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(data.error || "Error en la operación.");
  return data;
};

export const sbCambiarPasswordFree = (nuevaPassword) => llamarFreeFn("cambiar-password-free", { nuevaPassword });
export const sbActualizarLogoFree = (logoUrl) => llamarFreeFn("actualizar-logo-free", { logoUrl });
